import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appGalleryViewSmall]'
  })
export class GalleryViewSmallDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
